import {forwardRef} from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-select components
import Select, {components} from "react-select";

// base styles
import colors from "assets/theme/base/colors";

// Custom styles for SoftSelect
import styles from "components/SoftSelect/styles";

const SoftSelect = forwardRef(
  // eslint-disable-next-line react/prop-types
  ({ size, width, border, borderColor, error, success, background, ...rest }, ref) => {
    const { light } = colors;

    return (
      <Select
        {...rest}
        ref={ref}
        placeholder="Chọn..."
        components={{ NoOptionsMessage }}
        styles={styles(size, error, success, width, border, borderColor)}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: light.main,
            primary: light.main,
          },
        })}
        background={background}
      />
    );
  }
);

const NoOptionsMessage = (props) => {
  return (
    <components.NoOptionsMessage {...props}>
      <span>Không có kết quả nào</span>
    </components.NoOptionsMessage>
  );
};

// Setting default values for the props of SoftSelect
SoftSelect.defaultProps = {
  size: "medium",
  error: false,
  success: false,
  width: "100%",
  border: "",
  borderColor: "",
};

// Typechecking props for the SoftSelect
SoftSelect.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  width: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  border: PropTypes.string,
  borderColor: PropTypes.string,
};

export default SoftSelect;
